"use client";

import { useEffect, useRef, useState } from "react";
// import CountUp from "react-countup";

export type ProgressData = {
  title: string;
  bg: string;
  percent: number;
  width?: string;
  color: string;
};

export type ProgressBarProps = {
  progressData: ProgressData[];
};

/**
 * @name ProgressBar
 * @description Renders a list of progress bars with animated values.
 *
 * @param {Object} props - Component props.
 * @param {ProgressData[]} props.progressData - Array of progress data objects containing title, background, percent, width, and color.
 * @returns {JSX.Element} The rendered progress bars component.
 */
const ProgressBar = ({ progressData }: ProgressBarProps) => {
  const [isInView, setIsInview] = useState(false);
  const progress = useRef<HTMLUListElement | null>(null);
  useEffect(() => {
    const progressBars = Array.from(
      document.getElementsByClassName("bar") as HTMLCollectionOf<HTMLElement>
    );
    const observer = new IntersectionObserver((items) => {
      items.forEach((item) => {
        if (item.isIntersecting) {
          setIsInview(true);
        }
      });
    });
    for (const progressBar of progressBars) {
      observer.observe(progressBar);
    }
    // Clean up the observer when the component unmounts
    return () => {
      for (const progressBar of progressBars) {
        observer.unobserve(progressBar);
      }
    };
  }, []);
  return (
    <ul ref={progress} className="flex flex-col gap-5 lg:gap-[30px]">
      {progressData.map(({ bg, percent, title, color }) => (
        <li key={title}>
          <div className="mb-2 flex items-center justify-between">
            <span className="inline-block shrink-0 text-title">{title}</span>
            <span className={`inline-block shrink-0 ${color}`}>
              {/* <CountUp end={percent} enableScrollSpy={true} />% */}
            </span>
          </div>
          <div className="bar h-2 rounded-full w-full bg-transparent">
            <div
              className={`rounded-full ${bg} ${isInView ? "progress-grow" : ""} h-2`}
              style={{ width: `${Math.min(100, Math.max(0, percent))}%` }}
            ></div>
          </div>
        </li>
      ))}
    </ul>
  );
};
export default ProgressBar;
